import enUS from './enUS.js'
import deDE from './deDE.js'
import esES from './esES.js'
import esUS from './esUS.js'
import frFR from './frFR.js'
import itIT from './itIT.js'
import enUK from './enUK.js'
import enCA from './enCA.js'
import enAU from './enAU.js'
import enIN from './enIN.js'

type TranslationByLocale = Record<string, typeof enUS>

export const mapTranslationByLocale: TranslationByLocale = {
  'en-US': enUS,
  'en-GB': enUK,
  'en-AU': enAU,
  'en-CA': enCA,
  'en-IN': enIN,
  'de-DE': deDE,
  'es-ES': esES,
  'es-US': esUS,
  'fr-FR': frFR,
  'it-IT': itIT,
}

export function getTranslation(language: string) {
  return mapTranslationByLocale[language] ?? mapTranslationByLocale['en-US']
}

export const longWordsLanguages = ['de-DE', 'es-ES', 'es-US', 'fr-FR', 'it-IT']
